module.exports = __webpack_public_path__ + "static/img/group1.c0f1501f.png";